import { Component, OnInit } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { CommonService } from '../../../shared/services/common.service'
import { Router, ActivatedRoute } from '@angular/router'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'

@Component({
  standalone: false,
  selector: 'app-plp-homepage',
  templateUrl: './plp-homepage.component.html',
  styleUrls: ['./plp-homepage.component.scss'],
})
export class PlpHomepageComponent implements OnInit {
  categoryId: any = ''
  public categoryTypes
  public apiurl = environment.occBaseUrl
  sub: any

  constructor(
    private commonService: CommonService,
    private router: Router,
    private routes: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private globalMessageService: GlobalMessageService
  ) {}

  getCategoryDetails(categoryId) {
    this.categoryId = categoryId
    this.commonService
      .getData(
        environment.occBaseUrl +
          '/occ/v2/vsstore/vsCategories/' +
          this.categoryId
      )
      .subscribe(
        (success) => {
          this.categoryTypes = success
          const breadcrumb = []
          this.breadcrumbService.setBreadCrumbs(breadcrumb)
          this.breadcrumbService.setBreadcrumbTitle(success['name'])
          this.breadcrumbService.setShowHideBreadcrumb(true)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  ngOnInit(): void {
    this.sub = this.routes.params.subscribe(
      (params) => {
        // this.breadcrumbService.setBreadcrumbTitle(params.categoryId);
        this.categoryId = params['categoryCode']
        this.getCategoryDetails(this.categoryId)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
}
